import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setToken } from "../redux/authSlice";
import { signIn, userProfile } from "../services/auth";
import { setTokenData, setUserData } from "../utils/localStorage";
import { errorMessage } from "../utils/alertMessage";
import logo from "../assets/logoOG.png";
import image from "../assets/img/Data_security_01.jpg";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const [isFormSubmit, setIsFormSubmit] = useState(false)

  const dispatch = useDispatch();
  const usernameRef = useRef();
  const passwordRef = useRef();

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 90);


  const [startDateValue, setStartDateValue] = useState(initialStartDate);
  const [endDateValue, setEndDateValue] = useState(new Date());

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsFormSubmit(true);
    try {
      const response = await signIn({
        username: usernameRef.current.value,
        password: passwordRef.current.value,
      });

      if (response && response.data && !response.data.error) {
        const token = response.data.accessToken;
        const userResponse = await userProfile(token);

        if (userResponse && userResponse.data && !userResponse.data.error) {
          const userProfileData = userResponse.data;
          let userProfileRole = "";
          if (userProfileData.role === "ROLE_SUPER_ADMIN") {
            userProfileRole = "ROLE_SUPER_ADMIN";
          } else {
            userProfileRole = "";
          }
          localStorage.setItem("dataLimit", 100);
          localStorage.setItem(
            "startDateFilter",
            startDateValue.toISOString()
          );

          localStorage.setItem(
            "endDateFilter",
            endDateValue.toISOString()
          );
          setTokenData({ token });
          setUserData({ userProfileData });
          dispatch(setToken(token));
          setIsFormSubmit(false);
        } else {
          console.error("Error fetching user profile");
          setIsFormSubmit(false);
        }
      } else {
        console.error("Error:", response?.data?.message || "Unknown error");
        setIsFormSubmit(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setIsFormSubmit(false);
      errorMessage();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [])


  return (
    <main className="main">
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="card mb-3">
                  <div className="card-body flex">
                    {windowWidth > 600 && <div className="d-flex justify-content-center py-4 pl-3">
                      <div className="logo d-flex align-items-center w-auto">
                        <img
                          src={image}
                          alt="MVN Financeseva"
                          style={{ maxHeight: 400, width: 400 }}
                        />
                      </div>
                    </div>}
                    <div>
                      <div className="d-flex justify-content-center py-4">
                        <div className="logo d-flex align-items-center w-auto">
                          <span className="d-lg-block">
                            <img
                              src={logo}
                              alt="MVN Financeseva"
                              style={{ maxHeight: "100px" }}
                            />
                          </span>
                        </div>
                      </div>
                      <div className="pt-2 pb-2 text-center">
                        <h5 className="card-title pb-0 fs-4">Lead Management</h5>
                      </div>
                      <form
                        className="row g-3 needs-validation"
                        onSubmit={handleSubmit}
                      >
                        <div className="col-md-12">
                          <label htmlFor="mobile" className="form-label">
                            Username
                          </label>
                          <div className="input-group has-validation">
                            <input
                              ref={usernameRef}
                              type="text"
                              name="username"
                              className="form-control"
                              id="username"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="otp" className="form-label">
                            Password
                          </label>
                          <div className="input-group has-validation">
                            <input
                              ref={passwordRef}
                              type={showPassword ? "text" : "password"}
                              name="password"
                              className="form-control"
                              id="password"
                              required
                            />
                            {/* Move the eye icon inside the input box */}
                            <span
                              className="input-group-addon"
                              onClick={handleTogglePassword}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                left: "-10px",
                                marginLeft: "-15px"
                              }}
                            >
                              <i
                                className={`bi ${!showPassword
                                  ? "bi-eye-slash-fill"
                                  : "bi-eye-fill"
                                  }`}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="col-12">
                          <button className="btn btn-primary w-100" type="submit">
                            Login
                          </button>
                        </div>
                      </form>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Login;
